export const VAULTS_FYI_ARBITRUM_URL = 'https://arbitrum.vaults.fyi/'
export const VAULTS_FYI_BASE_URL = 'https://base.vaults.fyi/'
export const VAULTS_FYI_OPTIMISM_URL = 'https://op.vaults.fyi/'
export const VAULTS_FYI_POLYGON_URL = 'https://polygon.vaults.fyi/'
export const BACKEND_URL = import.meta.env['VITE_BACKEND_URL'] ?? ''
